// this is not setting any react states, so in a narrow sense this is not a hook
// yet it is changing the app's state via the document.body
const usePreventScrolling = () => {
  const setPreventScrolling = (preventScroll = true) => {
    if (preventScroll) {
      document.body.classList.add('hasOverlayActive');
    } else {
      document.body.classList.remove('hasOverlayActive');
    }
  };

  return { setPreventScrolling };
};

export default usePreventScrolling;
